import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import Icon from '../../ui/icons/Icon';
import iconsList from '../../ui/icons/iconsList';
import useClickOutside from '../../../hooks/useClickOutside';
import ScrollLTR from '../scrollLTR/ScrollLTR';
import classes from './DropDown.module.css';

const DropDown = ({ children, options, expanded, dropClass, arrowColor, height, value, showValue = true, closeOnApply = false, dropClassDropDown, optionClassName, hideSelectedInList = false, applyButtonText = 'בחירה כיתה' }) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [tempSelectedValue, setTempSelectedValue] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const selectRef = useRef();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 524);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useClickOutside(selectRef, () => setShowDropDown(false));

  useEffect(() => {
    showValue && setSelectedValue(value);
    showValue && setTempSelectedValue(value);
  }, [value, showValue]);

  const handleSelect = (option) => {
    if (isMobile && closeOnApply)
      setTempSelectedValue(option.value);
    else {
      option.onClick();
      showValue && setSelectedValue(option.value);
      !closeOnApply && setShowDropDown(false);
    }
  };

  const handleApply = () => {
    if (tempSelectedValue !== null) {
      const selectedOption = options.find(opt => opt.value === tempSelectedValue);
      if (selectedOption) {
        selectedOption.onClick();
        showValue && setSelectedValue(tempSelectedValue);
      }
    }
    setShowDropDown(false);
  };

  const displayedOptions = (hideSelectedInList && selectedValue) ? options.filter((o) => o.value !== selectedValue) : options;
  const currentDisplayValue = isMobile && closeOnApply ? tempSelectedValue : selectedValue;

  return (
    <div className={`${classes.Select} ${dropClass} ${showDropDown ? classes.Open : ''}`} ref={selectRef}>
      <AccessibilityClickableDiv className={classes.Value} onClick={() => setShowDropDown(prev => !prev)}>
        <div className={classes.ValueText}>
          {currentDisplayValue || children}
        </div>
        <div className={`${classes.Arrow} ${showDropDown ? classes.ArrowOpen : ''}`}>
          <Icon name={iconsList.down} color={arrowColor || `#070C43`} size="24px" />
        </div>
      </AccessibilityClickableDiv>

      {(showDropDown || expanded) &&
        <div className={`${classes.DropDown} ${dropClassDropDown}`}>
          <ScrollLTR height={isMobile ? '328px' : height} dropClass={classes.ScrollContainer}>
            {displayedOptions?.map((option) => (
              <AccessibilityClickableDiv key={option.key} className={`${classes.Option} ${optionClassName || ''}`} onClick={() => handleSelect(option)}>
                <span className={classes.OptionText}>{option.value}</span>
                {currentDisplayValue === option.value &&
                  <Icon name={iconsList.checkmarkGreen} size="15px" className={classes.Checkmark} />
                }
              </AccessibilityClickableDiv>
            ))}
          </ScrollLTR>
          {isMobile && closeOnApply && applyButtonText &&
            <div className={classes.ApplyButtonContainer}>
              <AccessibilityClickableDiv className={classes.ApplyButton} onClick={handleApply}>
                {applyButtonText}
              </AccessibilityClickableDiv>
            </div>
          }
        </div>
      }
    </div>
  );
};

export default DropDown;